import { Icon, type IconName } from "./Icon";

/**
 * A row action in a table (ADR 0030, phase C2). On desktop and tablets it is the familiar 32 px icon button with a
 * tooltip; in a phone card (`table-cards`, ≤719 px) the same button shows its text, so the action reads without
 * guessing an icon. The text is always in the DOM (visually hidden outside card mode), so the button has one
 * accessible name everywhere: `name` when the row needs to be spelled out ("Edit: Zone A"), otherwise `label`.
 */
export function RowAction({
  icon,
  label,
  name,
  onClick,
  danger,
  disabled,
  iconSize = 16,
}: {
  icon: IconName;
  /** Short visible text in card mode and the tooltip ("Edit"). */
  label: string;
  /** Full accessible name naming the row, when `label` alone would be ambiguous in a list. */
  name?: string;
  onClick: () => void;
  danger?: boolean;
  disabled?: boolean;
  iconSize?: number;
}) {
  return (
    <button
      type="button"
      className={`icon-button row-action${danger ? " row-action-danger" : ""}`}
      onClick={onClick}
      title={name ?? label}
      aria-label={name}
      disabled={disabled}
    >
      <Icon name={icon} size={iconSize} />
      <span className="row-action-label">{label}</span>
    </button>
  );
}
